var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientEngagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.4,
    height: 57.6,
    viewBox: "0 0 38.4 57.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12919",
    d: "M.3 6.2v45.6a6.007 6.007 0 0 0 6 6h26.4a6.007 6.007 0 0 0 6-6V6.2a6.007 6.007 0 0 0-6-6H6.3a6.007 6.007 0 0 0-6 6zM2.7 11h33.6v36H2.7zm30 44.4H6.3a3.6 3.6 0 0 1-3.6-3.6v-2.4h33.6v2.4a3.6 3.6 0 0 1-3.6 3.6zM6.3 2.6h26.4a3.6 3.6 0 0 1 3.6 3.6v2.4H2.7V6.2a3.6 3.6 0 0 1 3.6-3.6z",
    style: {
      fill: "#333"
    },
    transform: "translate(-.3 -.2)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12920",
    d: "m16.251 24.552-8.4 8.4 1.7 1.7 8.4-8.4z",
    style: {
      fill: "#d24350"
    },
    transform: "translate(-.3 -.2)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12921",
    d: "m29.451 22.151-16.8 16.8 1.7 1.7 16.8-16.8z",
    style: {
      fill: "#d24350"
    },
    transform: "translate(-.3 -.2)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12922",
    d: "m23.452 17.351-4.8 4.8 1.7 1.7 4.8-4.8z",
    style: {
      fill: "#d24350"
    },
    transform: "translate(-.3 -.2)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientEngagement);
export default __webpack_public_path__ + "static/media/patient-engagement.8944ecc1bff44aa39105121ebf989c2a.svg";
export { ForwardRef as ReactComponent };